module.exports = __webpack_public_path__ + "img/Path 112.cd7a4d7e.svg";